import React from 'react';
import MessageList from './Message-list';
import Input from './Input';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import {getFromStore, StorePath} from '../../services/store.service';
import PrivacyPolicy from '../common/Privacy-policy';
import MessageModel from '../../models/message.model';


const Chat = () => {
	const chatMessages = getFromStore(StorePath.MESSAGES) as MessageModel[];
	const showPrivacyPolicy = !chatMessages || chatMessages.length < 2;

	return (
		<>
			<Header/>
			<div className="bg-white p-4 text-sm grow overflow-y-auto">
				<MessageList/>
			</div>
			{showPrivacyPolicy && (
				<div className="bg-white">
					<PrivacyPolicy/>
				</div>
			)}
			<Input/>
			<Footer/>
		</>
	);
};

export default Chat;
